module.exports = __webpack_public_path__ + "img/icon_sort_header.75a18ba1.svg";